// extracted by mini-css-extract-plugin
module.exports = {"card":"style_card__KPHGS","name":"style_name__1POQd","description":"style_description__MVPLC","trainer":"style_trainer__1_tKy"};